import { AlertMessage } from '@app/core/models/alert/alert-message';
import { Action } from '@ngrx/store';

export enum AlertActionTypes {
  ShowAlert = '[Alert] Show Alert',
  HideAlert = '[Alert] Hide Alert',
  HideAllAlerts = '[Alert] Hide All Alerts'
}

export class ShowAlert implements Action {
  readonly type = AlertActionTypes.ShowAlert;
  constructor(public payload: AlertMessage) {}
}

export class HideAlert implements Action {
  readonly type = AlertActionTypes.HideAlert;
  constructor(public payload: AlertMessage) {}
}

export class HideAllAlerts implements Action {
  readonly type = AlertActionTypes.HideAllAlerts;
}

export type AlertActions =
  | ShowAlert
  | HideAlert
  | HideAllAlerts;
